import { Link } from 'react-router-dom';
import type { Video } from '@/mocks/videos';
import { formatDate } from '@/utils/format';

interface VideoCardProps {
  video: Video;
}

export default function VideoCard({ video }: VideoCardProps) {
  return (
    <Link
      to={`/video/${video.id}`}
      className="group flex flex-col bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition-colors cursor-pointer h-full"
    >
      <div className="relative w-full h-44 overflow-hidden">
        <img
          src={video.cover}
          alt={video.title}
          title={`${video.title} - 搞鸡趣味视频`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-foreground-950/20 group-hover:bg-foreground-950/35 transition-colors flex items-center justify-center">
          <span className="w-12 h-12 rounded-full bg-background-50/90 text-primary-600 flex items-center justify-center text-2xl group-hover:scale-110 transition-transform">
            <i className="ri-play-fill" />
          </span>
        </div>
        <span className="absolute bottom-2 right-2 text-[11px] px-2 py-0.5 rounded-md bg-foreground-950/75 text-background-50">
          {video.duration}
        </span>
        {video.episodes.length > 1 && (
          <span className="absolute top-2 left-2 text-[11px] px-2 py-0.5 rounded-md bg-accent-500 text-foreground-950 font-medium">
            共 {video.episodes.length} 集
          </span>
        )}
      </div>
      <div className="p-4 flex flex-col flex-1">
        <h3 className="font-heading text-base font-bold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
          {video.title}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed mt-2 line-clamp-2 flex-1">
          {video.description}
        </p>
        <div className="flex items-center justify-between mt-3.5 text-xs text-foreground-500">
          <span className="flex items-center gap-1.5">
            <i className="ri-user-3-line" /> {video.author}
          </span>
          <span>{formatDate(video.publishedAt)}</span>
        </div>
      </div>
    </Link>
  );
}